import logoOrange from '../../assets/logo-spassu-orange.svg';

export const LogoFull = () => (
  <img src={logoOrange} alt="Spassu" style={{ width: 'auto', height: 55 }} />
);
